import axios from "../../common/api/axios";
import { Software } from "./interface";

export const getSoftwares = async (): Promise<Software[]> => {
    const getSoftware = "software"
    const { data } = await axios.get(getSoftware);
    // console.log({ data });
    return data;
};